import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getHasCommentedOnDeviation } from '../../../../redux/deviations/selectors';
import { Props } from './CommentControl';

export type StateProps = Pick<Props, 'hasCommentedOn'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (state, { deviation }) => ({
  hasCommentedOn: getHasCommentedOnDeviation(state, deviation),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
